<script setup lang="ts">
defineProps<{
  field: string;
}>();
</script>

<template>
  <p v-if="field">
    {{ field === 'in_care' ? 'Shelter' : 'Field' }}
  </p>

  <span
    v-else
    class="flex flex-col items-start gap-0.5"
  >
    -
  </span>
</template>
